import { useMutation } from '@tanstack/react-query';
import { AxiosError } from 'axios';

import { managerTypes } from '../types';

import { axios } from '@/libraries/axios';
import { MutationConfig, queryClient } from '@/libraries/react-query';
import { managerMutationToasts } from '@/utils/managerMutationToasts';

const TOAST_ID = 'remove-manager';

export const removeManager: managerTypes.DeleteManager = (params) => {
  return axios.delete(`/manager`, { params });
};

type UseRemoveManagerOptions = {
  config?: MutationConfig<typeof removeManager>;
};

export function useRemoveManager({ config = {} }: UseRemoveManagerOptions = {}) {
  return useMutation({
    ...config,
    onMutate: (...args) => {
      managerMutationToasts.loading(TOAST_ID, 'Removing manager...');
      config.onMutate?.(...args);
    },
    onSuccess: (...params) => {
      queryClient.invalidateQueries(['managers']);
      managerMutationToasts.success(TOAST_ID, 'Manager removed successfully');
      config.onSuccess?.(...params);
    },
    onError: (error: AxiosError<{ error: string }>, ...args) => {
      const serverMessage = error.response?.data?.error;
      managerMutationToasts.error(TOAST_ID, serverMessage);
      config.onError?.(error, ...args);
    },
    mutationFn: removeManager,
  });
}
